import React, { useContext, useEffect } from 'react';
import { ContextOperacion, ContextOperacionType } from "../../RefactorLayout";
import { useLoader } from "../../../../hooks/useLoader";
import { EntityWithIdFields, QueryStatus } from "../../../../types";
import { Alert, Grid } from "@mui/material";
import { OperacionNOTES } from "./types/types";
import { SeccionFirmas } from "../../components/SeccionFirmas";
import { SistemaTipo } from "../../../../types/enum/enum";
import SeccionNOTESDatosOperacion from './components/SeccionNOTESDatosOperacion';
import { useOperacionNOTES } from './hooks/useOperacionNOTES';
import SeccionNOTESDatosSecciones from './components/SeccionNOTESDatosSecciones';
import SeccionNOTESOtrosParametros from './components/SeccionNOTESOtrosParametros';
import SeccionNOTESVisualizarArchivo from './components/SeccionNOTESVisualizarArchivo ';

interface SistemaNOTESContentProps {
  operacion: OperacionNOTES,
  codSistema: number,
}

const SistemaNOTESContent = ({ operacion, codSistema }: SistemaNOTESContentProps) => {

  return (
    <>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <SeccionNOTESDatosOperacion
            operacion={operacion}
          />
        </Grid>

        <Grid item xs={12}>
          <SeccionNOTESDatosSecciones operacion={operacion} />
        </Grid>

        <Grid item xs={12}>
          <SeccionNOTESOtrosParametros idOperacion={operacion[EntityWithIdFields.Id]} />
        </Grid>

        <Grid item xs={12}>
          <SeccionNOTESVisualizarArchivo idOperacion={operacion[EntityWithIdFields.Id]} />
        </Grid>

        <Grid item xs={12}>
          <Grid item xs={12}>
            <SeccionFirmas
              codSistema={SistemaTipo.NOTES}
              idOperacion={operacion.id}
            />
          </Grid>
        </Grid>

      </Grid>
    </>
  )
}

function SistemaNOTES() {
  const { idOperacion, codSistema } = useContext<ContextOperacionType>(ContextOperacion)

  const { status, operacion, } = useOperacionNOTES(idOperacion)

  const { showLoader, hideLoader } = useLoader()

  useEffect(() => {
    if (status === QueryStatus.Loading) {
      showLoader()
    } else {
      hideLoader();
    }
  }, [status])


  if (status === QueryStatus.Error) {
    return (
      <Alert severity='error'>
        Se produjo un error al cargar la operación.
      </Alert>
    )
  }

  else {

    if (!operacion) {
      return (
        <></>
      )
    }
  }

  return (
    <SistemaNOTESContent
      operacion={operacion}
      codSistema={codSistema}
    />
  )
}

export default SistemaNOTES;
